module.exports = "<div class=\"${require('../button-set/button-set.css').buttonSet}\" ng-transclude></div>\n";